module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAADgAAAAC98Dn6AAAA5UlEQVQoFX2SSw6CMBCGO024gx6A6IZ4BVgTwkaP6MoNjwPgBVy4EzwAHoKH/xBKCnacpDDTzjevlrIsuyqlAiK6pGlaQxelLMvjMAwFHGoN4AQlGMexyvP8IFEzVMHPh4+vIWfAHxh7CbagHfxarJTwUdsDBIpM2dLZBEowqiH0xOVNmeyACyjA5ILYdwU6YN5qPc8L4zhu2DCijfLv33XdT4IV6BiEOO0F3EJcHoYTSVc1gS6Ie0qS5IUWQhdMEmT3PL+ouz1h3ff9zWy4pscB5sdgZy74rT6wnhJkMhsYdgP/9xdF09p3NFJ4qQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/closeInfoBox.png
// module id = bSGN
// module chunks = 76